module.exports = __webpack_public_path__ + "static/img/invest-TMT3.e958210.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-TMT3.jpg
// module id = otMi
// module chunks = 0